import checkout from "./form";

const {
  formField: {
    checkbox1,
    checkbox2,
    checkbox3,
    taxCalculationPeriod,
    releaseTime,
    firstTime,
    supplementaryForThe,
    isExport,
    releaseInVietNam,
    billExportDate,
    taxpayerName,
    taxId,
    contract,
    checkbox4,
    checkbox5,
    taxId2,
    taxId3,
    moneyType,
    fullName,
    certificate,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [fullName.name]: "",
  [certificate.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
  [checkbox1.name]: false,
  [checkbox2.name]: false,
  [checkbox3.name]: false,
  [taxCalculationPeriod.name]: "",
  [releaseTime.name]: "",
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [isExport.name]: false,
  [releaseInVietNam.name]: false,
  [billExportDate.name]: "",
  [taxpayerName.name]: "",
  [taxId.name]: "",
  [contract.name]: "",
  [checkbox4.name]: false,
  [checkbox5.name]: false,
  [taxId2.name]: "",
  [taxId3.name]: "",
  [moneyType.name]: "",
};

export default initialValues;
